export const TOP_INDUSTRIES_COUNT = 5;
export const SELECT_INDUSTRIES_PLACEHOLDER = 'Select industries to target';
export const SELECT_INDUSTRIES_ALL_PLACEHOLDER = 'All industries';
